
import Vue from "vue";
import { searchSuggestion } from "../store/actions";
import { ITranslations } from "../store/state";
import { ITemplateFilter } from "../store/state";

interface HitCountComputed {
  totalHits: number;
  showingHits: number;
  hitCountText: string;
  suggestion?: string;
  translations: ITranslations;
  selectedFilters: ITemplateFilter[];
  amountOfShowingHits: number;
}
interface HitCountMethods {
  searchSuggestion(suggestion: string): void;
}

export default Vue.extend<{}, HitCountMethods, HitCountComputed, {}>({
  name: "HitCount",
  computed: {
    selectedFilters() {
      let filters = this.$store.getters.templateFilter;
      let selected = filters.filter(
        (filter: ITemplateFilter) => filter.selected
      );
      return selected;
    },
    totalHits() {
      return this.$store.getters.totalHits;
    },
    showingHits() {
      return this.$store.getters.showingHits;
    },
    hitCountText() {
      return this.amountOfShowingHits > 1
        ? `<strong>${this.amountOfShowingHits} ${this.translations.hits}</strong> ${this.translations.matchingYourQuery}`
        : `<strong>${this.amountOfShowingHits} ${this.translations.hit}</strong> ${this.translations.matchingYourQuery}`;
    },
    suggestion() {
      return this.$store.getters.suggestion;
    },
    translations() {
      return this.$store.getters.translations;
    },
    amountOfShowingHits() {
      return this.$store.getters.amountOfShowingHits;
    },
  },
  methods: {
    searchSuggestion(suggestion) {
      this.$store.dispatch(searchSuggestion(suggestion));
    },
  },
});
